/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentChatShareCandidates {
    getFixupPrototypeFunction() { return AgentChatShareCandidates.fixupPrototype; }

    static newInstance(model: Partial<AgentChatShareCandidates>): AgentChatShareCandidates {
        let obj = Object.assign(new AgentChatShareCandidates(), model);
        AgentChatShareCandidates.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentChatShareCandidates>): AgentChatShareCandidates {
        if (!model) return null;
        return AgentChatShareCandidates.newInstance(<AgentChatShareCandidates> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentChatShareCandidates) {
        if (!obj) return;

        models.AgentChatShareCandidates.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentChatShareCandidates): boolean {
        Object.setPrototypeOf(obj, AgentChatShareCandidates.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.users) {
            for (let val of this.users) {
                models.AgentChatParticipant.fixupPrototype(val);
            }
        }
    }

    /**
     * Users eligible to share the chat with
     */
    users: Array<models.AgentChatParticipant>;

}
